import request from '@/utils/request'

let Fposts_vip_cardApi = {

  /*会员卡列表*/
  list(data) {
    return request._post('/shop/plus.fposts_vip_card.Index/index', data);
},
/*添加会员卡*/
add(data) {
    return request._post('/shop/plus.fposts_vip_card.Index/add', data);
},
/*修改会员卡*/
edit(data) {
    return request._post('/shop/plus.fposts_vip_card.Index/edit', data);
},
/*删除会员卡*/
del(data) {
    return request._post('/shop/plus.fposts_vip_card.Index/del', data);
},
/*会员卡详情*/
detail(data) {
  return request._post('/shop/plus.fposts_vip_card.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.fposts_vip_card.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.fposts_vip_card.Setting/getSetting', data, errorback);
    },
}
export default Fposts_vip_cardApi;



// WEBPACK FOOTER //
// ./src/api/fposts_vip_card.js